var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("user-header", {
    attrs: {
      infoObj: _vm.infoObj
    }
  }), _c("div", {
    staticClass: "marginT20"
  }, [_c("a-card", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 10
      }
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("现所属部门")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.infoObj.structureName,
      callback: function ($$v) {
        _vm.$set(_vm.infoObj, "structureName", $$v);
      },
      expression: "infoObj.structureName"
    }
  })], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("上级")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      readOnly: true
    },
    model: {
      value: _vm.infoObj.structureName2,
      callback: function ($$v) {
        _vm.$set(_vm.infoObj, "structureName2", $$v);
      },
      expression: "infoObj.structureName2"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("迁移至"),
      prop: "structureId"
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      value: _vm.dataFrom.structureId,
      placeholder: _vm.$t("请选择") + _vm.$t("部门"),
      "tree-default-expand-all": "",
      "tree-data": _vm.treeData,
      replaceFields: {
        children: "children",
        title: "name",
        key: "key",
        value: "id"
      }
    },
    on: {
      change: _vm.onChange
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("指定上级"),
      prop: "structureId2"
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      value: _vm.dataFrom.structureId,
      placeholder: _vm.$t("请选择") + _vm.$t("上级"),
      "tree-default-expand-all": "",
      "tree-data": _vm.treeData,
      replaceFields: {
        children: "children",
        title: "name",
        key: "key",
        value: "id"
      }
    },
    on: {
      change: _vm.onChange
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("生效日期"),
      prop: "effectiveAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate(),
      "disabled-date": _vm.disabledDate
    },
    model: {
      value: _vm.dataFrom.effectiveAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "effectiveAt", $$v);
      },
      expression: "dataFrom.effectiveAt"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("下级迁移"),
      prop: "type2"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.type2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type2", $$v);
      },
      expression: "dataFrom.type2"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("同步迁移")) + " "), _c("a-button", {
    attrs: {
      type: "link"
    }
  }, [_vm._v(_vm._s(_vm.$t("下级人员同步迁移至新组织，上下级关系与职级不变")))])], 1), _c("a-radio", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("指定组织/人"))), _c("a-button", {
    attrs: {
      type: "link"
    }
  }, [_vm._v(_vm._s(_vm.$t("下级人员迁移至指定组织/人，职级不变")))])], 1), _c("a-radio", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("不迁移"))), _c("a-button", {
    attrs: {
      type: "link"
    }
  }, [_vm._v(_vm._s(_vm.$t("下级人员归属上级直辖，职级不变")))])], 1)], 1)], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("确认")) + " ")])], 1)], 1)], 1)], 1), _vm.postShow ? _c("post-model", {
    ref: "postForm",
    on: {
      cancel: function ($event) {
        _vm.postShow = false;
      },
      ok: _vm.getpostResourceFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };